import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { FaFacebook, FaWhatsapp, FaRegEnvelope } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import './styles.css';
import { format } from '~/Utils/Helpers';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';

const ArtePersonalizada = ({
  show,
  onHide,
  empreendimentoNome,
  codigoGrupoEmpresa,
}) => {
  const [imobiliariaSelecionada, setImobiliariaSelecionada] = useState('');
  const [logoImobiliaria, setLogoImobiliaria] = useState(null);
  const [nome, setNome] = useState('');
  const [creci, setCreci] = useState('');
  const [email, setEmail] = useState('');
  const [contato, setContato] = useState('');
  const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
  const [arteBase, setArteBase] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const fileInputRef = useRef(null);
  const previewRef = useRef(null);

  useEffect(() => {
    if (show && codigoGrupoEmpresa) {
      carregarArteBase();
    }
  }, [show, codigoGrupoEmpresa]);

  useEffect(() => {
    if (imobiliariaSelecionada) {
      carregarLogoImobiliaria();
    } else {
      setLogoImobiliaria(null);
    }
  }, [imobiliariaSelecionada]);

  const carregarLogoImobiliaria = async () => {
    try {
      const response = await api.BuscarLogoImob(imobiliariaSelecionada);
      setLogoImobiliaria(response);
    } catch (err) {
      console.error('Erro ao carregar logo da imobiliária:', err);
      setLogoImobiliaria(null);
    }
  };

  const carregarArteBase = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.SismacObterArteFacebook(codigoGrupoEmpresa);
      setArteBase(response);
    } catch (err) {
      var errorMsg =
        err && err.message ? err.message : 'Erro ao carregar arte base';
      setError(errorMsg);
      toast.error('Erro ao carregar arte base');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = event => {
    var file = event.target.files ? event.target.files[0] : null;
    if (file) {
      setArquivoSelecionado(file);

      var reader = new FileReader();
      reader.onloadend = function() {
        var base64 = reader.result.split(',')[1];
        var novaArte = Object.assign({}, arteBase, { conteudo_base64: base64 });
        setArteBase(novaArte);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleClose = () => {
    setImobiliariaSelecionada('');
    setLogoImobiliaria(null);
    setNome('');
    setCreci('');
    setEmail('');
    setContato('');
    setArquivoSelecionado(null);
    setArteBase(null);
    setError(null);
    onHide();
  };

  const handleFileInputClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const validarCampos = () => {
    if (!imobiliariaSelecionada) {
      toast.warning('Selecione uma imobiliária');
      return false;
    }
    if (!nome) {
      toast.warning('Preencha o nome');
      return false;
    }
    if (!creci) {
      toast.warning('Preencha o CRECI');
      return false;
    }
    if (!email) {
      toast.warning('Preencha o e-mail');
      return false;
    }
    if (!contato) {
      toast.warning('Preencha o contato');
      return false;
    }
    return true;
  };

  const handleBaixarArte = async () => {
    if (!validarCampos()) return;

    setDownloading(true);
    try {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');

      var img = new Image();
      img.crossOrigin = 'anonymous';

      var logoImg = null;
      if (logoImobiliaria) {
        logoImg = new Image();
        logoImg.crossOrigin = 'anonymous';
        await new Promise(function(resolve, reject) {
          logoImg.onload = resolve;
          logoImg.onerror = resolve;
          logoImg.src = logoImobiliaria;
        });
      }

      await new Promise(function(resolve, reject) {
        img.onload = function() {
          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0);

          var areaAzulAltura = img.height * 0.22;
          var areaAzulY = img.height - areaAzulAltura;

          var logoBoxSize = areaAzulAltura * 0.75;
          var logoBoxX = 25;
          var logoBoxY = areaAzulY + (areaAzulAltura - logoBoxSize) / 2;

          ctx.fillStyle = 'white';
          ctx.fillRect(logoBoxX, logoBoxY, logoBoxSize, logoBoxSize);

          if (logoImg && logoImg.complete && logoImg.naturalWidth > 0) {
            var logoMaxSize = logoBoxSize * 0.85;
            var logoScale = Math.min(
              logoMaxSize / logoImg.width,
              logoMaxSize / logoImg.height
            );
            var logoW = logoImg.width * logoScale;
            var logoH = logoImg.height * logoScale;
            var logoX = logoBoxX + (logoBoxSize - logoW) / 2;
            var logoY = logoBoxY + (logoBoxSize - logoH) / 2;
            ctx.drawImage(logoImg, logoX, logoY, logoW, logoH);
          }

          ctx.fillStyle = 'white';
          ctx.textAlign = 'left';
          var textoX = logoBoxX + logoBoxSize + 20;
          var textoY = areaAzulY + areaAzulAltura * 0.45;

          ctx.font = 'bold ' + Math.round(areaAzulAltura * 0.18) + 'px Arial';
          ctx.fillText(nome, textoX, textoY);

          ctx.font = Math.round(areaAzulAltura * 0.1) + 'px Arial';
          ctx.fillText(
            'CRECI: ' + creci,
            textoX,
            textoY + areaAzulAltura * 0.2
          );

          ctx.textAlign = 'right';
          var textoRightX = img.width - 15;

          ctx.font = Math.round(areaAzulAltura * 0.1) + 'px Arial';
          ctx.fillText(
            'FALE COMIGO:',
            textoRightX,
            areaAzulY + areaAzulAltura * 0.22
          );

          ctx.font = 'bold ' + Math.round(areaAzulAltura * 0.14) + 'px Arial';
          ctx.fillText(contato, textoRightX, areaAzulY + areaAzulAltura * 0.45);

          ctx.font = Math.round(areaAzulAltura * 0.14) + 'px Arial';
          ctx.fillText(email, textoRightX, areaAzulY + areaAzulAltura * 0.68);

          resolve();
        };
        img.onerror = reject;
        img.src = 'data:image/png;base64,' + arteBase.conteudo_base64;
      });

      var base64 = canvas.toDataURL('image/png').split(',')[1];

      var response = await api.SismacGerarArteFacebookPersonalizada({
        conteudo_base64: base64,
        nome_arquivo: 'PeçasFace.png',
      });

      var link = document.createElement('a');
      link.href =
        'data:' + response.tipo_mime + ';base64,' + response.conteudo_base64;
      link.download = response.nome_arquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success('Arte baixada com sucesso!');
    } catch (err) {
      var errorMsg = err && err.message ? err.message : 'Erro ao baixar arte';
      toast.error(errorMsg);
    } finally {
      setDownloading(false);
    }
  };

  const handleAlterarArte = async () => {
    if (!arquivoSelecionado) {
      toast.warning('Selecione um arquivo antes de alterar a arte');
      return;
    }

    setUploading(true);
    try {
      var reader = new FileReader();
      reader.onloadend = async function() {
        var base64 = reader.result.split(',')[1];

        await api.SismacUploadArteFacebook(codigoGrupoEmpresa, {
          nome_arquivo: 'pecasFB.png',
          conteudo_base64: base64,
        });

        toast.success('Arte alterada com sucesso!');
        setArquivoSelecionado(null);
        await carregarArteBase();
      };
      reader.readAsDataURL(arquivoSelecionado);
    } catch (err) {
      var errorMsg = err && err.message ? err.message : 'Erro ao alterar arte';
      toast.error(errorMsg);
    } finally {
      setUploading(false);
    }
  };

  var arteBaseConteudo =
    arteBase && arteBase.conteudo_base64 ? arteBase.conteudo_base64 : null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="xl"
      centered
      dialogClassName="sismac_modal sismac_modal--fullwidth"
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ color: '#fff' }}>
          <FaFacebook style={{ marginRight: 8, color: '#1877f2' }} />
          Peças para Facebook
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
            <p className="mt-2">Carregando arte base...</p>
          </div>
        )}

        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        {!loading && (
          <Row>
            <Col xs={12} lg={5} className="mb-4 mb-lg-0">
              <Form.Group className="mb-3">
                <Form.Label>Imobiliária *</Form.Label>
                <Form.Control
                  as="select"
                  value={imobiliariaSelecionada}
                  onChange={e => setImobiliariaSelecionada(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="dni">DNI</option>
                  <option value="fenix">FENIX</option>
                  <option value="jh">JH</option>
                  <option value="sgi">SGI</option>
                  <option value="staff">STAFF</option>
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Nome *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Nome Sobrenome"
                  value={nome}
                  onChange={e => setNome(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Creci *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Ex.: 000.000-SP"
                  value={creci}
                  onChange={e => setCreci(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>E-mail *</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="email@dominio.com.br"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Contato/Whatsapp *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="(17) 99999-9999"
                  value={contato}
                  onChange={e => setContato(e.target.value)}
                />
              </Form.Group>

              <p className="text-muted small">(*) Campos obrigatórios</p>

              <Button
                variant="primary"
                className="w-100"
                onClick={handleBaixarArte}
                disabled={downloading}
              >
                {downloading ? (
                  <>
                    <Spinner animation="border" size="sm" className="mr-2" />
                    Gerando arte...
                  </>
                ) : (
                  'Baixar arte personalizada'
                )}
              </Button>
            </Col>

            <Col xs={12} lg={7}>
              <Row className="mb-3 align-items-center">
                <Col xs={12} sm={6} className="mb-2 mb-sm-0">
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept="image/png"
                    onChange={handleFileChange}
                  />
                  <div className="d-flex align-items-center">
                    {AuthStorage.temCaracteristica(
                      caracteristicas.GerencialSismac
                    ) && (
                      <>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          className="text-nowrap"
                          onClick={handleFileInputClick}
                        >
                          Escolher arquivo
                        </Button>
                        <span
                          className="ml-2 text-muted small text-truncate"
                          style={{ maxWidth: 150 }}
                        >
                          {arquivoSelecionado
                            ? arquivoSelecionado.name
                            : 'Nenhum arquivo escolhido'}
                        </span>
                      </>
                    )}
                  </div>
                </Col>
                <Col xs={12} sm={6} className="text-sm-right">
                  {AuthStorage.temCaracteristica(
                    caracteristicas.GerencialSismac
                  ) && (
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleAlterarArte}
                      disabled={!arquivoSelecionado || uploading}
                    >
                      {uploading ? (
                        <>
                          <Spinner
                            animation="border"
                            size="sm"
                            className="mr-2"
                          />
                          Enviando...
                        </>
                      ) : (
                        'Alterar Arte'
                      )}
                    </Button>
                  )}
                </Col>
              </Row>

              <div
                ref={previewRef}
                className="position-relative bg-white border rounded overflow-hidden"
                style={{ minHeight: 500 }}
              >
                {arteBaseConteudo ? (
                  <>
                    <img
                      src={'data:image/png;base64,' + arteBaseConteudo}
                      alt="Arte base"
                      className="w-100"
                      style={{ display: 'block' }}
                    />
                    <div
                      className="position-absolute w-100 d-flex text-white"
                      style={{
                        bottom: 0,
                        left: 0,
                        height: '22%',
                        pointerEvents: 'none',
                      }}
                    >
                      <div
                        className="d-flex align-items-center p-2 p-md-3"
                        style={{ flex: 1 }}
                      >
                        <div
                          className="bg-white rounded d-flex align-items-center justify-content-center mr-2 mr-md-3"
                          style={{ width: 80, height: 80, minWidth: 80 }}
                        >
                          {logoImobiliaria ? (
                            <img
                              src={logoImobiliaria}
                              alt="Logo imobiliária"
                              style={{
                                maxWidth: 70,
                                maxHeight: 70,
                                objectFit: 'contain',
                              }}
                            />
                          ) : (
                            <span
                              className="text-muted small text-center"
                              style={{ fontSize: 10 }}
                            >
                              Logo
                            </span>
                          )}
                        </div>
                        <div>
                          <div
                            className="font-weight-bold"
                            style={{ fontSize: 22 }}
                          >
                            {nome || 'Seu Nome'}
                          </div>
                          <div style={{ fontSize: 16 }}>
                            CRECI: {creci || '000.000-SP'}
                          </div>
                        </div>
                      </div>
                      <div
                        className="d-flex flex-column justify-content-center p-2 p-md-3 text-right"
                        style={{ flex: 1 }}
                      >
                        <div className="mb-1" style={{ fontSize: 14 }}>
                          FALE COMIGO:
                        </div>
                        <div
                          className="font-weight-bold mb-1"
                          style={{ fontSize: 20 }}
                        >
                          <FaWhatsapp />{' '}
                          {format.celular(contato) || '(17) 99999-9999'}
                        </div>
                        <div style={{ fontSize: 16 }}>
                          <FaRegEnvelope /> {email || 'email@dominio.com.br'}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ minHeight: 500 }}
                  >
                    <span className="text-muted">Nenhuma arte disponível</span>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ArtePersonalizada;
